// components/FAQ.jsx
import React, { useState } from "react";

export default function FAQ() {
  const [active, setActive] = useState(null);

  const faqData = [
    {
      q: "What is this resume builder?",
      a: "A tool to create a professional resume using templates.",
    },
    {
      q: "Is it free?",
      a: "Yes, free templates with premium upgrades available.",
    },
    {
      q: "Do I need an account?",
      a: "You can build without an account, but saving requires login.",
    },
    {
      q: "Are templates ATS-friendly?",
      a: "Yes, they pass most ATS scanners.",
    },
    {
      q: "Can I edit later?",
      a: "Yes, log in anytime.",
    },
    {
      q: "Do you offer cover letters?",
      a: "Yes, matching cover letters included.",
    },
  ];

  return (
    <div className="faq-section">
      <div className="faq-title">
        <h4>Frequently Asked Questions</h4>
      </div>

      {faqData.map((item, i) => (
        <div
          key={i}
          className={`faq ${active === i ? "active" : ""}`}
          onClick={() => setActive(active === i ? null : i)}
        >
          <div className="faq-question">{item.q}</div>
          <div className="faq-answer">{item.a}</div>
        </div>
      ))}
    </div>
  );
}
